export default "__VITE_ASSET__DwZCJIe$__"